import * as CapabilityType from '../../constants/CapabilityType'
import {userCan} from '../../login/Security'
import {MoreMenuItem, separator} from "./MoreMenuItem";
import * as ts from "../../common/Translator";
import {translateMessage} from "../../common/Translator";
import * as CommonFieldIds from "../../constants/CommonFieldIds";
import * as GenericActions from "../../constants/GenericActions";
import {isReplicateOptions} from "../../routing/NestMode";
import {ajaxJSON, areEqual, areNotEqual, isAnyEqualToFirst, isEmptyOrNull, isNotEmptyOrNull} from "../../common/NamaCommon";
import * as DomainBaseEntities from '../../constants/DomainBaseEntities'
import * as BSEntities from '../../constants/BSEntities'
import {findEntityMaxReviseCount, getEntityCustomReports, getEntityTemplates, isDocument, isFifoCost} from '../../login/ClientCache'
import {canBeRevised, canBeUnRevised, isInNewMode} from '../edit/EditScreenToolbar'
import {ViewVersionMoreMenuItem} from "./ViewVersionMoreMenuItem";
import * as entities from "../../constants/EntitiesWithLedgerEffectsOrWithParents";
import {entitiesWithLedgerEffects, scCostDocs, scLedgerDocs} from "../../constants/EntitiesWithLedgerEffectsOrWithParents";
import * as ShowCustomRepIn from '../../constants/ShowCustomRepIn'
import {QuestionFieldsEditor} from "../../widgets/QuestionFieldsEditor";
import {ActionPerformer} from "../../widgets/ActionPerformer";
import * as FieldType from "../../constants/FieldType";
import * as CommonConstants from "../../constants/CommonConstants";
import {find} from "../../common/HasIDUtil";
import * as urls from "../../constants/NamaURLS";
import {SimpleEntityView} from "./SimpleEntityView";
import * as SimpleEntities from "../../constants/SimpleEntities";
import {JSCriteriaBuilder} from "../../common/JSCriteriaBuilder";
import * as AccountingValueObjectIDs from "../../constants/AccountingValueObjectIDs";
import * as FAEntities from "../../constants/FAEntities";
import {showFieldInfo_, showIDs} from "../../common/GUIUtilities";
import {ActionHandler} from "../../widgets/ActionHandler";
import {of} from "../../widgets/ActionPlaceholder";
import {constructMoreActionsMenu} from "./MoreActionsMenu";
import {NamaKendoWindow, NamaWindowBtnData} from "../NamaKendoWindow";
import {CustomReportLauncherMenuItem} from "./CustomReportLauncherMenuItem";

export function questionFiled(capabilityId, referenceEntityType, fieldType, allowedValues) {
    let questionField = {};
    questionField.id = capabilityId;
    let metaData = {};
    metaData.id = capabilityId;
    if (!fieldType) {
        metaData.fieldType = FieldType.Reference;
    } else {
        metaData.fieldType = fieldType;
    }
    metaData.referencedEntityType = referenceEntityType;
    if (allowedValues)
        metaData.allowedValues = allowedValues;
    questionField.metaData = metaData;
    return questionField;
}

/**
 *
 * @param capabilityId
 * @param {EditPresenter} presenter
 * @returns {DTOFilledQuestionField}
 */
function capFilledQuestion(capabilityId, presenter) {
    let filledQuestion = {};
    filledQuestion.id = capabilityId;
    filledQuestion.objValue = presenter.getFieldValue(capabilityId);
    if (filledQuestion.objValue)
        filledQuestion.value = filledQuestion.objValue.id + CommonConstants.FIELD_PARTS_SEP + filledQuestion.objValue.entityType +
            CommonConstants.FIELD_PARTS_SEP + filledQuestion.objValue.code + CommonConstants.FIELD_PARTS_SEP + filledQuestion.objValue.actualCode
            + CommonConstants.FIELD_PARTS_SEP + filledQuestion.objValue.name1 + CommonConstants.FIELD_PARTS_SEP + filledQuestion.objValue.name2;
    return filledQuestion;
}

/**
 *
 * @param {EditPresenter} presenter
 * @returns {Array}
 */
function getStandardMoreMenuItems(presenter) {
    let standardMoreMenuItems = [];
    standardMoreMenuItems.push(new MoreMenuItem("showErrors", presenter, () => {
        //TODO: show errors
    }));
    standardMoreMenuItems.push(new MoreMenuItem("changeCapabilities", presenter, () => {
        let questionFieldsEditor = new QuestionFieldsEditor(presenter.entityType);
        let actionHandler = new ActionHandler();
        actionHandler.performer = new ActionPerformer();
        actionHandler.performer.performAction = () => {
            let filledQuestions = questionFieldsEditor.getQuestionFields();
            /**
             * @type {namaTypes.ChangeCapacitiesRequest}
             */
            let request =
                {
                    id: presenter.record.id,
                    entityType: presenter.entityType,
                    viewCapability: find(CommonFieldIds.VIEW_CAPABILITY, filledQuestions).objValue ? find(CommonFieldIds.VIEW_CAPABILITY, filledQuestions).objValue.id : null,
                    usageCapability: find(CommonFieldIds.USAGE_CAPABILITY, filledQuestions).objValue ? find(CommonFieldIds.USAGE_CAPABILITY, filledQuestions).objValue.id : null,
                    updateCapability: find(CommonFieldIds.UPDATE_CAPABILITY, filledQuestions).objValue ? find(CommonFieldIds.UPDATE_CAPABILITY, filledQuestions).objValue.id : null,
                };
            ajaxJSON(urls.Change_Capabilities, {
                    request: JSON.stringify(request)
                }, (result) => {
                    presenter.showRecordSavedMsg();
                }
            );
        };
        actionHandler.questionFieldsEditor = questionFieldsEditor;
        actionHandler.actionInfo = of("changeCapabilities");
        let questionFields = [];
        questionFields.push(questionFiled(CommonFieldIds.VIEW_CAPABILITY, BSEntities.SecurityCapability));
        questionFields.push(questionFiled(CommonFieldIds.UPDATE_CAPABILITY, BSEntities.SecurityCapability));
        questionFields.push(questionFiled(CommonFieldIds.USAGE_CAPABILITY, BSEntities.SecurityCapability));
        let window = new NamaKendoWindow("changeCapabilities", new NamaWindowBtnData("ok", () => {
            actionHandler.performer.performAction(actionHandler.actionInfo.getId(), actionHandler.questionFieldsEditor.getQuestionFields(), presenter.metaData, presenter);
            window.closeWindow();
        }), new NamaWindowBtnData("cancel"));
        let filledQuestions = [];
        filledQuestions.push(capFilledQuestion(CommonFieldIds.VIEW_CAPABILITY, presenter));
        filledQuestions.push(capFilledQuestion(CommonFieldIds.UPDATE_CAPABILITY, presenter));
        filledQuestions.push(capFilledQuestion(CommonFieldIds.USAGE_CAPABILITY, presenter));
        questionFieldsEditor.edit(questionFields, filledQuestions, null, null, presenter, window, window);
        window.showWindow();
    }));
    if (!presenter.isViewOnlyMode()) {
        if (presenter.isUsagePrevented() === true)
            standardMoreMenuItems.push(new MoreMenuItem("allowUsage", presenter, () => {
                presenter.setFieldValue(CommonFieldIds.PREVENT_USAGE, false);
            }));
        else
            standardMoreMenuItems.push(new MoreMenuItem("preventUsage", presenter, () => {
                presenter.setFieldValue(CommonFieldIds.PREVENT_USAGE, true);
            }));
        if (presenter.preventUseAsFromDoc() === true)
            standardMoreMenuItems.push(new MoreMenuItem("allowUsageAsFromDoc", presenter, () => {
                presenter.setFieldValue(CommonFieldIds.PREVENT_USE_AS_FROMDOC, false);
            }));
        else
            standardMoreMenuItems.push(new MoreMenuItem("preventUsageAsFromDoc", presenter, () => {
                presenter.setFieldValue(CommonFieldIds.PREVENT_USE_AS_FROMDOC, true);
            }));
    }
    if (presenter.isApprovalPending())
        standardMoreMenuItems
            .push(new MoreMenuItem(GenericActions.REVOKE_APPROVAL_REQUEST, presenter));
    if (isReplicateOptions()) {
        standardMoreMenuItems.push(new MoreMenuItem(GenericActions.REREPLICATE_RECORD, presenter));
        standardMoreMenuItems.push(new MoreMenuItem(GenericActions.RECOMMIT_RECORD, presenter));
        if (entitiesWithLedgerEffects.contains(presenter.entityType) || scCostDocs.contains(presenter.entityType) || scLedgerDocs.contains(presenter.entityType))
            standardMoreMenuItems.push(new MoreMenuItem(GenericActions.REGEN_ACCOUNTING_EFFECTS, presenter));
        if (isDocument(presenter.entityType))
        {
            standardMoreMenuItems.push(new MoreMenuItem(GenericActions.REGEN_INVENTORY_EFFECTS, presenter));
            standardMoreMenuItems.push(new MoreMenuItem(GenericActions.CHANGE_VALUE_DATE_FOR_SELECTED_DOCUMENTS, presenter));
        }
        if (isAnyEqualToFirst(presenter.entityType, DomainBaseEntities.User, DomainBaseEntities.MasterGroup, DomainBaseEntities.Sector,
            DomainBaseEntities.Branch, DomainBaseEntities.Department, DomainBaseEntities.LegalEntity, DomainBaseEntities.AnalysisSet,
            DomainBaseEntities.DocumentBook, DomainBaseEntities.DocumentTerm, BSEntities.DocCategory, BSEntities.FiscalPeriod,
            BSEntities.FiscalYear, BSEntities.SecurityCapability))
            standardMoreMenuItems.push(new MoreMenuItem("cancelActivated", presenter));
        standardMoreMenuItems.push(new MoreMenuItem("ShowIds", presenter, () => {
            showIDs(presenter);
        }));
        standardMoreMenuItems.push(new MoreMenuItem("ShowFieldInfo", presenter, () => {
            showFieldInfo_();
        }));
        standardMoreMenuItems.push(new MoreMenuItem(GenericActions.ADD_MANUAL_CODING_PREFIX, presenter));
        if (areEqual(presenter.entityType, BSEntities.ReportDefinition)) {
            standardMoreMenuItems.push(separator(presenter));
            standardMoreMenuItems.push(new MoreMenuItem("updateSystemReports", presenter));
            standardMoreMenuItems.push(new MoreMenuItem("openImplementationRepo", presenter, () => {
                window.location.href = "https://crm.namasoft.com/erp/repobrowser.html?exportTo=" + window.location.origin;
            }));
        }
    }
    standardMoreMenuItems.push(new MoreMenuItem(GenericActions.VIEW_AUDIT_TRAIL, presenter));
    standardMoreMenuItems.push(new MoreMenuItem(GenericActions.VIEW_DETAILED_AUDIT_TRAIL, presenter));
    standardMoreMenuItems.push(new MoreMenuItem(GenericActions.SET_AS_TEMPLATE, presenter));
    let templates = getEntityTemplates(presenter.entityType);
    if (templates) {
        standardMoreMenuItems.push(separator(presenter));
        for (let templateMetadata of templates) {
            if (!templateMetadata.doNotAddToMoreMenu || templateMetadata.doNotAddToMoreMenu === false) {
                standardMoreMenuItems.push(new MoreMenuItem(ts.translateRef(templateMetadata), presenter, () => {
                    presenter.onNewRecord(templateMetadata.template.id);
                }));
            }

        }
    }
    standardMoreMenuItems.push(separator(presenter));
    let useReviseDocument = findEntityMaxReviseCount(presenter.entityType).useReviseDocument;
    if (useReviseDocument) {
        if (canBeRevised())
            standardMoreMenuItems.push(new MoreMenuItem(GenericActions.CREATE_REVISION_DOC, presenter));
        if (canBeUnRevised())
            standardMoreMenuItems.push(new MoreMenuItem(GenericActions.CREATE_UNREVISION_DOC, presenter));
        standardMoreMenuItems.push(new MoreMenuItem(GenericActions.VIEW_REVISION_DOCS, presenter));
        standardMoreMenuItems.push(separator(presenter));
    }
    standardMoreMenuItems.push(new MoreMenuItem(GenericActions.VIEW_RELATED_DMS_DOCUMENTS, presenter));
    standardMoreMenuItems.push(new MoreMenuItem(GenericActions.CREATE_DMS_DOCUMENT, presenter));
    standardMoreMenuItems.push(separator(presenter));
    standardMoreMenuItems.push(new MoreMenuItem(GenericActions.VIEW_RELATED_REMARKS, presenter));
    standardMoreMenuItems.push(new MoreMenuItem(GenericActions.CREATE_REMARK, presenter));
    if (userCan(presenter.entityType, CapabilityType.Import))
        standardMoreMenuItems.push(new MoreMenuItem(GenericActions.IMPORT_RECORDS, presenter));
    if (userCan(presenter.entityType, CapabilityType.Export))
        standardMoreMenuItems.push(new MoreMenuItem(GenericActions.EXPORT_CURRENT, presenter));
    standardMoreMenuItems.push(separator(presenter));
    standardMoreMenuItems.push(new MoreMenuItem(GenericActions.VIEW_RELATED_MEETING_REMARKS, presenter));
    standardMoreMenuItems.push(new MoreMenuItem(GenericActions.CREATE_MEETING_REMARK, presenter));
    standardMoreMenuItems.push(separator(presenter));
    standardMoreMenuItems
        .push(new MoreMenuItem(GenericActions.ADDTOAGENDA, presenter));
    standardMoreMenuItems.push(new MoreMenuItem(GenericActions.VIEW_RELATED_DETAILED_REMARKS, presenter));
    standardMoreMenuItems.push(new MoreMenuItem(GenericActions.CREATE_DETAILED_REMARK, presenter));
    standardMoreMenuItems
        .push(new MoreMenuItem(GenericActions.ADD_TO_CURRENT_USER_FAVOURITES, presenter));
    standardMoreMenuItems
        .push(new MoreMenuItem(GenericActions.REMOVE_FROM_CURRENT_USER_FAVOURITES, presenter));

    standardMoreMenuItems.push(separator(presenter));
    let currentVersion = presenter.currentVersion();
    if (!isInNewMode(presenter) && currentVersion != null && currentVersion > 1) {
        let viewVersions = [];
        for (let i = currentVersion - 1; i > currentVersion - 6 && i > 0; i--) {
            if (areNotEqual(i, presenter.place.version))
                viewVersions.push(new ViewVersionMoreMenuItem(i, presenter));
        }
        let addedSep = false;
        if (isNotEmptyOrNull(presenter.place.version)) {
            viewVersions.push(separator(presenter));
            addedSep = true;
            viewVersions.push(new ViewVersionMoreMenuItem(null, presenter));
        }
        if (currentVersion > 6) {
            if (!addedSep) {
                viewVersions.push(separator(presenter));
                addedSep = true;
            }
            viewVersions.push(new ViewVersionMoreMenuItem(-1, presenter));
        }
        let versionsSubItems = [];
        for (let viewerVersion of viewVersions) {
            versionsSubItems.push(new MoreMenuItem(viewerVersion.id, presenter, viewerVersion.clickFunction, viewerVersion.title));
        }
        standardMoreMenuItems.push(new MoreMenuItem("versions", presenter, () => {
        }, undefined, versionsSubItems));
    }
    return standardMoreMenuItems;
}

/**
 *
 * @param {EditPresenter | ListPresenter} presenter
 * @param {Array} moreMenuButtons
 * @param {EditLayout | ListLayout} layout
 */
export function createActionsMoreMenuItems(presenter, moreMenuButtons, layout) {
    if (!layout)
        return;
    if (isEmptyOrNull(layout.moreActions))
        return;
    for (let moreAction of layout.moreActions) {
        if (moreAction.id || moreAction.customization)
            moreMenuButtons.push(new MoreMenuItem(moreAction.id, presenter));
    }
}

/**
 *
 * @param {Array} params
 * @param {JSCriteriaBuilder} scCriteria
 */
function addCostTransType(params, scCriteria) {
    if (isFifoCost()) {
        params.push({
            entityType: SimpleEntities.FifoCostTrans,
            criteria: scCriteria
        });
    } else {
        params.push({
            entityType: SimpleEntities.CostInTrans,
            criteria: scCriteria
        });
        params.push({
            entityType: SimpleEntities.CostOutTrans,
            criteria: scCriteria
        });
    }
}

function getProviderMoreMenuItems(matchingEntitiesParams, ownerEntityType, moreMenuButtons, presenter, toolbar) {
    if (!userCan(ownerEntityType, CapabilityType.CanViewTransaction))
        return moreMenuButtons;
    setTimeout((e) => {
        ajaxJSON(urls.ListSimpleEntitiesMatchingRef, {
                request: JSON.stringify(matchingEntitiesParams)
            }, (result) => {
                if (result) {
                    for (let simpleEntityRef of result) {
                        moreMenuButtons.push(
                            new MoreMenuItem("showGeneratedSystemTransaction" + simpleEntityRef.type, presenter, () => {
                                let criteria = new JSCriteriaBuilder();
                                criteria = criteria.field(CommonFieldIds.ID).equal(simpleEntityRef.id);
                                new SimpleEntityView(simpleEntityRef.type, criteria);
                            }, translateMessage("showGeneratedSystemTransaction") + ":" + translateMessage(simpleEntityRef.type))
                        );
                    }
                }
                constructMoreActionsMenu(moreMenuButtons, toolbar, presenter)
            }
        );
    }, 155);

}

function glCriteria(id) {
    let criteriaBuilder = new JSCriteriaBuilder();
    criteriaBuilder = criteriaBuilder.field("trnsData.originId").equal(id);
    return criteriaBuilder;
}

/**
 *
 * @param {EditPresenter} presenter
 * @param {Array} moreMenuButtons
 */
function getServerDependantExtraMoreMenuItems(presenter, moreMenuButtons, toolbar) {
    let ownerId = presenter.metaData.owner.ownerId;
    let id = presenter.getFieldValue("id");
    let criteria = glCriteria(id);
    let matchingEntitiesParams = {};
    matchingEntitiesParams.params = [];
    matchingEntitiesParams.params.push({
        entityType: SimpleEntities.LedgerTrans,
        criteria: criteria
    });
    if (entities.scCostDocs.contains(ownerId)) {
        let scCriteria = new JSCriteriaBuilder().field("data.originId").equal(id);
        addCostTransType(matchingEntitiesParams.params, scCriteria);
        getProviderMoreMenuItems(matchingEntitiesParams, ownerId, moreMenuButtons, presenter, toolbar);
    } else if (entities.scLedgerDocs.contains(ownerId) || FAEntities.FATransferDocument === ownerId) {
        getProviderMoreMenuItems(matchingEntitiesParams, ownerId, moreMenuButtons, presenter, toolbar);
    } else {
        constructMoreActionsMenu(moreMenuButtons, toolbar, presenter)
    }
}


/**
 *
 * @param {EditPresenter} presenter
 * @param {Array} moreMenuButtons
 */
function getExtraMoreMenuItems(presenter, moreMenuButtons, toolbar) {
    let ownerId = presenter.metaData.owner.ownerId;

    if (!isInNewMode(presenter)) {
        if (userCan(ownerId, CapabilityType.CanViewTransaction)
            && entities.entitiesWithLedgerEffects.contains(ownerId)) {
            moreMenuButtons.push(new MoreMenuItem("showGeneratedSystemTransaction", presenter, () => {
                let criteria = new JSCriteriaBuilder();
                criteria = criteria.field(AccountingValueObjectIDs.LedgerTrans_trnsData_originId).equal(presenter.getFieldValue("id"));
                new SimpleEntityView(SimpleEntities.LedgerTrans, criteria);
            }));
        }
    }
    let entityCustomReports = getEntityCustomReports(ownerId);
    if (entityCustomReports) {
        moreMenuButtons.push(separator(presenter));
        for (let customRepInfo of entityCustomReports) {
            if (isEmptyOrNull(customRepInfo.showIn) || areEqual(customRepInfo.showIn, ShowCustomRepIn.EditViewMore)) {
                moreMenuButtons.push(new CustomReportLauncherMenuItem(presenter, customRepInfo));
            }
        }
    }
    getServerDependantExtraMoreMenuItems(presenter, moreMenuButtons, toolbar);
}

/**
 *
 * @param {EditPresenter} presenter
 * @returns {Array}
 */
export function getMoreMenuItems(presenter) {
    let toolbar = presenter.view.find(".editScreen#toolbar");
    if (!userCan(presenter.entityType, CapabilityType.CanViewMoreMenu))
        return [];
    let moreMenuButtons = getStandardMoreMenuItems(presenter);
    createActionsMoreMenuItems(presenter, moreMenuButtons, presenter.editLayout);
    if (presenter.currentApprovalCase()) {
        moreMenuButtons.push(new MoreMenuItem("showCurrentApproval", presenter, () => {
            new SimpleEntityView(SimpleEntities.ApprovalCase, presenter.currentApprovalCase());
        }));
    }
    getExtraMoreMenuItems(presenter, moreMenuButtons, toolbar);
    return moreMenuButtons;
}